import { render, staticRenderFns } from "./DialogueBoxVoteResult.vue?vue&type=template&id=0496bae4&scoped=true"
import script from "./DialogueBoxVoteResult.vue?vue&type=script&lang=ts"
export * from "./DialogueBoxVoteResult.vue?vue&type=script&lang=ts"
import style0 from "./DialogueBoxVoteResult.vue?vue&type=style&index=0&id=0496bae4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496bae4",
  null
  
)

export default component.exports